import { clearMockData } from './clearMockData';
import { getMockListData, getMockListDataAsync } from './getMockData';
import { setMockData } from './setMockData';

interface Params<T, P = any> {
  key: string;

  find: (...params: P[]) => (record: T) => boolean;
}

export const createMockFunctions = <T, P = any>({
  key,
  ...params
}: Params<T, P>) => {
  const set = setMockData<T[]>(key);
  const list = getMockListData<T[]>(key);
  const listAsync = getMockListDataAsync<T[]>(key);
  const clear = clearMockData(key);

  const get = async (...p: P[]) => (await listAsync()).find(params.find(...p));

  return {
    list,
    listAsync,
    set,
    clear,
    get,
  };
};
